var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import uuidv4 from 'uuid/v4';
import { getDefaultRoomId, sendWsMessage, sendConnectionRequestMessage, sendPing, respondPingMessage, } from './ws-v1';
import { clearSearchValue } from './http';
import { log } from './log';
import config from '../../electron/package.json';
import { getBrowserName, getBrowserVersion, getOS, getOSVersion } from './index';
const isTest = process.env.NODE_ENV === 'test';
let socketId;
let socket;
let v2Manager;
const invalidate = (socketId_) => {
    if (socketId !== socketId_) {
        return;
    }
    if (socket) {
        socket.close();
    }
    socket = undefined;
    socketId = undefined;
};
const handleWs = (ws, id) => {
    invalidate(socketId);
    socket = ws;
    socketId = id;
};
// Creates a new socket connected to socketUrl. If secondary is false, the socket
// created will be 'main' socket, returned by getSocket. Otherwise it will be a
// 'secondary' socket.
const createNewSocket = (socketUrl, secondary = false) => {
    return new Promise((resolve, reject) => {
        const sId = uuidv4();
        if (isTest)
            return;
        const ws = new WebSocket(socketUrl);
        const logBackendErrors = ({ data }) => {
            const parsedData = JSON.parse(data);
            if (parsedData && parsedData.type === 'error') {
                // eslint-disable-next-line no-console
                log('ws-backend-error', 'error', parsedData);
            }
        };
        ws.onopen = () => {
            log('websocketStatus', 'info', {
                event: 'opened',
                url: socketUrl,
                success: true,
            });
            ws.addEventListener('message', logBackendErrors);
            if (!secondary)
                handleWs(ws, sId);
            resolve(ws);
        };
        ws.onerror = (error) => {
            log('websocketStatus', 'error', {
                event: 'error',
                url: socketUrl,
                success: true,
                error,
            });
            if (!secondary)
                invalidate(sId);
            clearSearchValue(window, 'token');
            reject(new Error('Websocket error'), { cause: error });
        };
        ws.onclose = (res) => {
            log('websocketStatus', 'info', {
                event: 'closed',
                url: socketUrl,
                success: true,
                reason: res.reason,
                code: res.code,
            });
            clearSearchValue(window, 'token');
            ws.removeEventListener('message', logBackendErrors);
            if (!secondary)
                invalidate(sId);
        };
    });
};
export const getSocket = () => {
    if (isTest) {
        return { send: () => { } };
    }
    if (socket)
        return socket;
    throw new Error('no socket found.');
};
export const getSocketIfExist = () => socket;
export const getSocketId = () => socketId;
export default getSocket;
export const createScribeSocket = (url, handleScribeDashboardMessage) => __awaiter(void 0, void 0, void 0, function* () {
    const socket = yield createNewSocket(url, true);
    socket.addEventListener('message', (data) => {
        const message = JSON.parse(data.data);
        handleScribeDashboardMessage(message);
    });
    return socket;
});
export const createV1Socket = (url, user, options) => __awaiter(void 0, void 0, void 0, function* () {
    let ping;
    const { roomId, request, scribe: scribeOption } = options;
    const scribe = user.features.scribe && scribeOption;
    yield createNewSocket(url);
    const defaultRoomId = getDefaultRoomId(user.uid || user.id);
    const lastRoomId = roomId || defaultRoomId;
    window.onunload = () => {
        clearInterval(ping);
        if (socket) {
            socket.send(JSON.stringify({
                type: 'connection-params-update',
                roomId: getDefaultRoomId(user.uid || user.id),
            }));
        }
    };
    socket.v1 = true;
    socket.addEventListener('message', (message) => {
        var _a, _b;
        const data = JSON.parse(message.data);
        if (data.type === 'webrtc') {
            // WebRTCManager can handle messages even before it is initialized.
            //getSingletonWebRTCManager().handleV1Message(data);
        }
        if (data.type === 'connection-succeeded') {
            ping = setInterval(() => {
                sendPing(socket);
            }, 1000 * 10);
            // We only allow the WebRTCManager to send data after the server
            // signals that it's ready with connection-succeeded.
            /*
            getSingletonWebRTCManager().initialize((message) => {
              sendWsMessage(socket, {
                type: 'webrtc',
                ...message,
              });
            });
             */
        }
        if (data.type === 'PING') {
            respondPingMessage(socket, data);
        }
        if (data.type === 'room-status' || data.type === 'room-status-update') {
            if (data.type === 'room-status' && data.id && data.id !== lastRoomId) {
                if (scribe) {
                    sendWsMessage(socket, {
                        type: 'connection-params-update',
                        roomId: data.id,
                        downAudio: {
                            speakerId: (_a = data.audioStreams[0]) === null || _a === void 0 ? void 0 : _a.avaId,
                            trackId: (_b = data.audioStreams[0]) === null || _b === void 0 ? void 0 : _b.trackId,
                        },
                    });
                }
            }
        }
    });
    const type = !window.isElectron ? 'web' : 'desktop';
    const appVersion = config.version;
    const system = getOS();
    const operationSystem = getOSVersion() || 'Unknown';
    const browserName = getBrowserName();
    const browserVersion = getBrowserVersion() || 'Unknown';
    const client = {
        type,
        appVersion,
        system,
        os: operationSystem,
        device: 'Unknown',
        browserName,
        browserVersion,
    };
    socket.send(JSON.stringify({
        type: 'connection-params',
        speakerId: user.parse.avaId,
        roomId: roomId || getDefaultRoomId(user.uid || user.id),
        username: user.parse.userName,
        client,
        downAudio: scribe
            ? {
                host: true,
            }
            : undefined,
        conversationMode: 'public',
    }));
    if (request && request.avaName) {
        const fromSource = 'default';
        sendConnectionRequestMessage(socket, fromSource, { avaName: request.avaName });
    }
});
